var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"el-menu-demo",attrs:{"active-text-color":"#006A60","default-active":_vm.$route.path,"router":true}},[_c('sub-menu',{attrs:{"menu-list":_vm.menuList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }